export const WebProductOptionModuleName = 'Product Option';